import React from 'react';

export const GraphSvg = (props: { fillColor: string }) => {
  const { fillColor = '#252525' } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5649_4162)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7316 6.72512C19.9484 6.94196 19.9484 7.29351 19.7316 7.51035L13.0688 14.1732C12.852 14.39 12.5004 14.39 12.2836 14.1732L9.90001 11.7896L5.2955 16.3941C5.07867 16.6109 4.72711 16.6109 4.51028 16.3941C4.29345 16.1773 4.29345 15.8257 4.51028 15.6089L9.5074 10.6118C9.72423 10.3949 10.0758 10.3949 10.2926 10.6118L12.6762 12.9953L18.9464 6.72512C19.1632 6.50829 19.5148 6.50829 19.7316 6.72512Z"
          fill={fillColor}
        />

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3398 7.11774C14.3398 6.81109 14.5884 6.5625 14.8951 6.5625H19.337C19.6436 6.5625 19.8922 6.81109 19.8922 7.11774V11.5596C19.8922 11.8663 19.6436 12.1149 19.337 12.1149C19.0303 12.1149 18.7817 11.8663 18.7817 11.5596V7.67297H14.8951C14.5884 7.67297 14.3398 7.42438 14.3398 7.11774Z"
          fill={fillColor}
        />

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3402 18.8174C19.3402 19.1049 19.1071 19.3379 18.8197 19.3379H4.66116C4.37368 19.3379 4.14062 19.1049 4.14062 18.8174V18.8174C4.14062 18.5299 4.37368 18.2969 4.66116 18.2969H18.8197C19.1071 18.2969 19.3402 18.5299 19.3402 18.8174V18.8174Z"
          fill={fillColor}
        />
      </g>

      <defs>
        <clipPath id="clip0_5649_4162">
          <rect
            width="17.7675"
            height="17.7675"
            fill="white"
            transform="translate(3.23438 3.23438)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
